/* ============================================================================
   Fit Experience (KS) — EasySize integration helpers

   - Registers size_update_function on window.easysize_globals so EasySize
     (theme snippet AND app block) picks the correct Shopify option when
     length is baked into the size value (e.g. "XS long").
   - Wires the "Find My Size" CTA to the EasySize widget.
   - Watches the page for EasySize-rendered DOM mutations and rewrites a few
     button labels + the "We recommend size X" string to match brand voice.

   Must load early (no defer) so size_update_function exists before EasySize
   merges window.easysize_globals into its config.
   ========================================================================== */

(function () {
  "use strict";

  // Guard: even if the asset is included twice, only initialise once.
  if (window.__ksFitExperienceLoaded) return;
  window.__ksFitExperienceLoaded = true;

  // EasySize sends size + length separately ("XS" + "long"), but our variants
  // are one option value ("XS long"). Recombine when that option exists.
  window.easysize_globals = window.easysize_globals || {};
  window.easysize_globals.size_update_function = function (size) {
    var value = String(size || "").trim();
    var length = "";
    try {
      var es = window.EasySizeParametersDebug.easysize;
      value = es.original_calculated_size.size || value;
      length =
        es.original_calculated_size.recommended_length ||
        es.recommended_fit ||
        "";
    } catch (e) {}

    var selects = document.querySelectorAll(
      "form.product-form-main select[data-variant-select]"
    );
    if (!selects.length) {
      selects = document.querySelectorAll("select[data-variant-select]");
    }
    if (!selects.length) return false;

    var candidates = length ? [value + " " + length, value] : [value];
    for (var c = 0; c < candidates.length; c++) {
      var candidate = String(candidates[c] || "").trim();
      if (!candidate) continue;

      for (var i = 0; i < selects.length; i++) {
        for (var o = 0; o < selects[i].options.length; o++) {
          var optionValue = selects[i].options[o].value;
          if (!optionValue) continue;
          if (optionValue.toLowerCase() === candidate.toLowerCase()) {
            selects[i].value = optionValue;
            selects[i].dispatchEvent(new Event("change", { bubbles: true }));
            return true;
          }
        }
      }
    }
    return false;
  };

  function initFitExperience() {
    var ksButton = document.querySelector(".ks-fit .size-finder-button");

    if (ksButton) {
      ksButton.addEventListener("click", function (event) {
        event.preventDefault();

        var easySizeButton = document.getElementById("easysize_button");
        if (easySizeButton) {
          easySizeButton.click();
          return;
        }

        if (window.easy_size && typeof window.easy_size.open === "function") {
          window.easy_size.open();
          return;
        }

        console.warn("EasySize button not found.");
      });
    }

    document.querySelectorAll(".ks-fit-subaccordion").forEach(function (item) {
      item.removeAttribute("open");
    });

    ksUpdateEasySizeUI();
    observeEasySizeChanges();
  }

  // Übersetzte Strings kommen aus theme.liquid (window.ksI18n) — Fallback Englisch.
  // Read lazily: this file loads in <head> before ksI18n is defined.
  function getFitI18n() {
    var i18n = window.ksI18n || {};
    return {
      addToCart: i18n.fitAddToCart || "ADD TO CART",
      returnToShopping: i18n.fitReturnToShopping || "RETURN TO SHOPPING",
      retakeQuiz: i18n.fitRetakeQuiz || "RETAKE FIT QUIZ",
      recommendedSize: i18n.fitRecommendedSize || "Recommended size for you:",
    };
  }

  function ksUpdateEasySizeUI() {
    var labels = getFitI18n();

    document.querySelectorAll("button, a").forEach(function (el) {
      // textContent replaces the whole button. Quick-ATC triggers keep an icon
      // inside; rewriting them leaves "ADD TO CART" in the mobile bag button.
      if (el.classList.contains("bs-quick-atc-trigger") || el.closest(".bs-quick-atc")) return;

      var text = el.textContent.trim().toLowerCase();

      if (text === "add to cart") {
        el.textContent = labels.addToCart;
      }

      if (text === "return to your shopping") {
        el.textContent = labels.returnToShopping;
      }

      if (text === "redo the quiz") {
        el.textContent = labels.retakeQuiz;
      }
    });

    document.querySelectorAll(".easysize_button__returning").forEach(function (el) {
      var text = el.textContent.trim();
      var match = text.match(/We recommend size (.+)/i);

      if (match) {
        el.textContent = labels.recommendedSize + " " + match[1];
      }
    });
  }

  function observeEasySizeChanges() {
    if (!("MutationObserver" in window)) return;

    var scheduled = false;

    function schedule() {
      if (scheduled) return;
      scheduled = true;

      var run = function () {
        scheduled = false;
        ksUpdateEasySizeUI();
      };

      if ("requestAnimationFrame" in window) {
        requestAnimationFrame(run);
      } else {
        setTimeout(run, 16);
      }
    }

    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFitExperience);
  } else {
    initFitExperience();
  }
})();
